/**
 * Telloport Design System corner radii (px).
 * sm stays G1; md+ are candidates for G2 squircle (stroked edges stay G1 unless opted in).
 */
export const TELLOPORT_RADIUS = {
    none: 0,
    sm: 4,
    md: 8,
    lg: 12,
    xl: 16,
    '2xl': 20,
    '3xl': 24,
    full: 9999
} as const;

/** Primary UI font — loaded via Google Fonts in each app `index.html`. */
export const TELLOPORT_FONT_FAMILY = "'Montserrat', ui-sans-serif, system-ui, sans-serif";

/**
 * Telloport Design System typography scale (px / unitless line-height / weight / tracking).
 * Mirror in each Telloport-default app `@theme` + `.type-*` utilities.
 */
export const TELLOPORT_TYPE = {
    display: { fontSize: 40, lineHeight: 46, fontWeight: 800, letterSpacing: '-0.01em' },
    heading: { fontSize: 26, lineHeight: 32, fontWeight: 700, letterSpacing: '-0.01em' },
    subheading: { fontSize: 17, lineHeight: 24, fontWeight: 600, letterSpacing: '0' },
    body: { fontSize: 15, lineHeight: 24, fontWeight: 400, letterSpacing: '0' },
    label: { fontSize: 12, lineHeight: 16, fontWeight: 600, letterSpacing: '0.08em' },
    accentQuote: { fontSize: 22, lineHeight: 30, fontWeight: 300, letterSpacing: '0' }
} as const;

export type TelloportTypeRole = keyof typeof TELLOPORT_TYPE;

/**
 * Telloport Design System spacing scale (px).
 * Keys match DS `space-N` names — there is no `space-5`; `space-6` is 60px (not 48).
 * Mirror in each Telloport-default app `@theme` as `--spacing-space-N` → `p-space-N` / `gap-space-N`.
 */
export const TELLOPORT_SPACING = {
    1: 8,
    2: 16,
    3: 24,
    4: 32,
    6: 60
} as const;

export type TelloportSpacingStep = keyof typeof TELLOPORT_SPACING;
